import cn from 'classnames';
import { useState } from 'react';
import { useIntl } from 'react-intl';

import { Tooltip } from '@/shared/ui';

import { i18n } from '../../config';
import { DiagnocoinBalanceRow } from '../DiagnocoinBalanceRow/DiagnocoinBalanceRow';

import styles from './CurrentOrganizationRow.module.scss';
import { Row } from './Row';

type CurrentOrganizationRowProps = {
  className?: string;
  organizationName: string;
  initials: string;
  avatarSrc: string;
  onClick: () => void;
};

export const CurrentOrganizationRow = (props: CurrentOrganizationRowProps) => {
  const { className, organizationName, avatarSrc, initials, onClick } = props;
  const { formatMessage } = useIntl();

  const [shouldShowTooltip, setShouldShowTooltip] = useState(false);

  return (
    <div
      className={cn(styles.container, className)}
      data-component="current-organization-display"
    >
      <h3 className="h3m">{formatMessage(i18n.currentClinic)}</h3>

      {shouldShowTooltip ? (
        <Tooltip.Primary content={organizationName}>
          <Row
            organizationName={organizationName}
            initials={initials}
            onClick={onClick}
            avatarSrc={avatarSrc}
            showTooltipHandler={setShouldShowTooltip}
          />
        </Tooltip.Primary>
      ) : (
        <Row
          organizationName={organizationName}
          initials={initials}
          onClick={onClick}
          avatarSrc={avatarSrc}
          showTooltipHandler={setShouldShowTooltip}
        />
      )}

      <DiagnocoinBalanceRow className={styles.balance} />
    </div>
  );
};
